import { useState, useEffect } from "react"
import { authFetch } from "../../utils/api"

const API = process.env.REACT_APP_API_URL
const NUEVA = "__nueva__"

function AltaUsuario({ refreshKey, onUsuarioCreado }) {
  const [form, setForm] = useState({
    cuit: "",
    email: "",
    password: "",
    confirmar: "",
    role: "OBRA_SOCIAL",
    obraSocialId: "",
    obraSocialNombre: "",
  })
  const [obras, setObras]     = useState([])
  const [mensaje, setMensaje] = useState(null)

  useEffect(() => {
    authFetch(`${API}/obras-sociales`).then(r => r.json()).then(setObras)
  }, [refreshKey])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
      ...(name === "obraSocialId" && { obraSocialNombre: "" }),
    }))
  }

  const handleSubmit = async () => {
    setMensaje(null)
    if (!form.cuit || !form.password) {
      setMensaje({ tipo: "error", texto: "CUIT y contraseña son obligatorios" })
      return
    }
    if (form.password !== form.confirmar) {
      setMensaje({ tipo: "error", texto: "Las contraseñas no coinciden" })
      return
    }
    if (form.role === "OBRA_SOCIAL") {
      if (!form.obraSocialId) {
        setMensaje({ tipo: "error", texto: "Seleccioná una obra social" })
        return
      }
      if (form.obraSocialId === NUEVA && !form.obraSocialNombre.trim()) {
        setMensaje({ tipo: "error", texto: "Ingresá el nombre de la nueva obra social" })
        return
      }
    }

    try {
      const body = {
        cuit: form.cuit,
        email: form.email || undefined,
        password: form.password,
        role: form.role,
        ...(form.role === "OBRA_SOCIAL" && form.obraSocialId !== NUEVA && { obraSocialId: form.obraSocialId }),
        ...(form.role === "OBRA_SOCIAL" && form.obraSocialId === NUEVA && { obraSocialNombre: form.obraSocialNombre.trim() }),
      }
      const res = await authFetch(`${API}/usuarios`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensaje({ tipo: "error", texto: err.error || "Error al crear usuario" })
        return
      }
      setMensaje({ tipo: "ok", texto: "Usuario creado correctamente" })
      setForm({ cuit: "", email: "", password: "", confirmar: "", role: "OBRA_SOCIAL", obraSocialId: "", obraSocialNombre: "" })
      onUsuarioCreado?.()
    } catch {
      setMensaje({ tipo: "error", texto: "Error de conexión" })
    }
  }

  return (
    <div className="adminPanel column">

      <div className="adminPanelTitle row">
        <i className="fa-solid fa-user-plus"></i>
        DAR DE ALTA UN USUARIO
      </div>

      <div className="adminSection">
        <div className="adminSectionLabel">datos de acceso</div>

        <div className="adminRow" style={{ flexWrap: "nowrap" }}>
          <div className="adminField adminField--grow">
            <label>cuit (usuario)</label>
            <input type="text" name="cuit" placeholder="sin guiones" value={form.cuit} onChange={handleChange} />
          </div>
          <div className="adminField adminField--grow">
            <label>email</label>
            <input type="email" name="email" placeholder="correo electrónico" value={form.email} onChange={handleChange} />
          </div>
          <div className="adminField adminField--grow">
            <label>contraseña</label>
            <input type="password" name="password" placeholder="contraseña" value={form.password} onChange={handleChange} />
          </div>
          <div className="adminField adminField--grow">
            <label>confirmar</label>
            <input type="password" name="confirmar" placeholder="repetir contraseña" value={form.confirmar} onChange={handleChange} />
          </div>
        </div>
      </div>

      <div className="adminSection">
        <div className="adminSectionLabel">rol y permisos</div>

        <div className="adminRow">
          <div className="adminField">
            <label>rol</label>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <label><input type="radio" name="role" value="OBRA_SOCIAL" checked={form.role === "OBRA_SOCIAL"} onChange={handleChange} /> obra social</label>
              <label><input type="radio" name="role" value="ADMIN" checked={form.role === "ADMIN"} onChange={handleChange} /> administrador</label>
              <label><input type="radio" name="role" value="OBSERVADOR" checked={form.role === "OBSERVADOR"} onChange={handleChange} /> observador</label>
            </div>
          </div>
        </div>

        {form.role === "OBRA_SOCIAL" && (
          <div className="adminRow">
            <div className="adminField">
              <label>obra social</label>
              <select name="obraSocialId" value={form.obraSocialId} onChange={handleChange} style={{ width: 220 }}>
                <option value="">seleccionar...</option>
                {obras.map(os => (
                  <option key={os.id} value={os.id}>{os.nombre}</option>
                ))}
                <option value={NUEVA}>— nueva obra social —</option>
              </select>
            </div>
            {form.obraSocialId === NUEVA && (
              <div className="adminField">
                <label>nombre de la nueva obra social</label>
                <input
                  type="text"
                  name="obraSocialNombre"
                  placeholder="nombre"
                  value={form.obraSocialNombre}
                  onChange={handleChange}
                  style={{ width: 200 }}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {mensaje && (
        <div className={`adminMensaje adminMensaje--${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="adminBtnRow">
        <button className="adminBtn adminBtn--primary" onClick={handleSubmit}>crear usuario</button>
      </div>

    </div>
  )
}

export default AltaUsuario
